$(document).ready(function () {

    $("#mi-corpo-display-product-documentation-product-selector").on('change',
        function () {
            $("#mi-corpo-display-product-documentation-loading-img").css("display", "block");
            var requestManager = new AsyncRequestManager();
            var productName =
                encodeURIComponent($('#mi-corpo-display-product-documentation-product-selector option:selected')
                    .text());
            var language = $('html').attr('lang');

            requestManager.renderAsyncRequest('/userdocumentation-display/search-product', '?productName=' + productName, '#mi-corpo-userdoc', false, language);
            //requestManager.renderAsyncRequest('/userdocumentation-display/search-product', '?productName=' + $('#mi-corpo-display-product-documentation-product-selector option:selected').text(), '[data-widget="elcadisplayproductdocumentation"]', true);
            //$("#mi-corpo-display-product-documentation-loading-img").css("display", "none");
        });

    $("#mi-corpo-display-product-documentation-language-selector").on('change',
        function () {

            $('#mi-corpo-display-product-documentation-product-documents-links').children('div').each(function () {

                if (($.trim($(this).find(".lang").text()) ==
                    $("#mi-corpo-display-product-documentation-language-selector option:selected").val() ||
                    $("#mi-corpo-display-product-documentation-language-selector option:selected").val() == "") &&
                    ($.trim($(this).find(".categ").attr('name')) ==
                    $("#mi-corpo-display-product-documentation-document-type-selector option:selected").val() ||
                    $("#mi-corpo-display-product-documentation-document-type-selector option:selected").val() == "") ){
                    //display
                    //console.log('found');
                    $(this).show();
                } else {
                    //hide row
                    $(this).hide();
                }
            });
        });

    $("#mi-corpo-display-product-documentation-document-type-selector").on('change',
        function () {

            $('#mi-corpo-display-product-documentation-product-documents-links').children('div').each(function () {
                if (($.trim($(this).find(".lang").text()) ==
                        $("#mi-corpo-display-product-documentation-language-selector option:selected").val() ||
                        $("#mi-corpo-display-product-documentation-language-selector option:selected").val() == "") &&
                    ($.trim($(this).find(".categ").attr('name')) ==
                        $("#mi-corpo-display-product-documentation-document-type-selector option:selected").val() ||
                        $("#mi-corpo-display-product-documentation-document-type-selector option:selected").val() == "")) {
                    //display
                    //console.log('found');
                    $(this).show();
                } else {
                    //hide row
                    $(this).hide();
                }
            });
        });
});

function geoLocalizationUserDoc() {
    if ($("#widgetBlock").val() == "False") {

        $.getJSON("https://api.ipify.org?format=json",
            function (data) {
                $.getJSON("/Sitefinity/Public/Services/GeoLocation/GeoLocation.svc/" + data.ip,
                    function () {
                    })
                    .done(function (userIpCountry) {
                        var jsonParse = JSON.parse(userIpCountry);

                        if (jsonParse.ErrorMessage) {
                            alert("Error ocurred while detecting user location");
                        } else {
                            saveAccessAndCheckAllowedCountry(
                                jsonParse.Ip,
                                jsonParse.GeoLocationDateTime,
                                jsonParse.IsoCode,
                                jsonParse.Country,
                                jsonParse.City,
                                jsonParse.Region
                            );
                            return userIpCountry;
                        }

                    })
                    .fail(function () {
                        //alert('fail=' + data);
                    })
                    .always(function () {
                        //console.log( "complete" );
                        $("#mi-corpo-elcauserdoc-loading-img").css("display", "none");

                    });
                });
    }

}

function saveAccessAndCheckAllowedCountry(ip, dateTime, isocode, country, city, region) {
    var queryString = "?" +
        $(".mi-corpo-UserDoc-hidden-data-form").serialize() + 
        "&ip=" +
        ip +
        "&dateTime=" +
        dateTime +
        "&isocode=" +
        isocode +
        "&country=" +
        country +
        "&city=" +
        city +
        "&region=" +
        region +
        "&lang=" +
        document.documentElement.lang;
    var requestManager = new AsyncRequestManager();
    requestManager.renderSyncRequest('/UserDoc/saveAccessAndCheckAllowedCountry', queryString, '#mi-corpo-userdoc');
}